import { render, staticRenderFns } from "./GlobalButton.vue?vue&type=template&id=972e5800&scoped=true&"
import script from "./GlobalButton.vue?vue&type=script&lang=js&"
export * from "./GlobalButton.vue?vue&type=script&lang=js&"
import style0 from "./GlobalButton.vue?vue&type=style&index=0&id=972e5800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972e5800",
  null
  
)

export default component.exports